import React from 'react'
import { Button } from 'sutra/components/Button'
import {
  PopoverModal,
  type PopoverModalSize,
} from 'sutra/components/PopoverModal'

import { ModalTitle } from 'components/share-resource/ShareResourceModal/styles'

export interface ShareResourceModalProps {
  isOpen: boolean
  onClose: () => void
  /** Titles the modal as `Share "{resourceName}"`. */
  resourceName: string
  /** The data-owning feature adapter (e.g. `AgentSharing`, `PromptSharing`).
   * Rendered as a child, not passed `ShareResourceProps` directly, so it only
   * mounts — and fetches — while the modal is open; `PopoverModal` returns
   * `null` when closed. */
  children: React.ReactNode
  size?: PopoverModalSize
}

/** Wraps `ShareResource` (via `children`) in the sutra `PopoverModal` shell,
 * so any resource's sharing UI can be rendered inline or in a modal from the
 * same component. */
export function ShareResourceModal({
  isOpen,
  onClose,
  resourceName,
  children,
  size = 'md',
}: ShareResourceModalProps): React.ReactElement {
  return (
    <PopoverModal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      title={<ModalTitle forwardedAs="span">Share “{resourceName}”</ModalTitle>}
      content={children}
      footer={
        <Button variant="secondary" size="sm" height="32px" onClick={onClose}>
          Close
        </Button>
      }
    />
  )
}

ShareResourceModal.displayName = 'ShareResourceModal'
